import axios from 'axios';
import ProjectConfig from 'ProjectConfig';
import normalizeInternalRemoteConfigs from './normalizeInternalRemoteConfigs';

const TIMEOUT_MS = 5000;

/**
 * Fetches remote configs from Internal API and returns a flat string map.
 * @returns {Promise<Object.<string, string>>}
 */
export default async function fetchInternalRemoteConfig () {
  const url = `${ProjectConfig.API_GATEWAY}/content/v1/remote-configs`;
  const response = await axios.get(url, { timeout: TIMEOUT_MS });
  return normalizeInternalRemoteConfigs(response.data);
}
